import { Pagination } from "@/components/General/Pagination/pagination.container";
import { useReviewsContext } from "@/components/Product/Reviews/context/reviews.context";
import { PAGE_SIZE } from "@/components/Product/Reviews/reviews.config";
import * as UseFeatureTracker from "@/services/tracking/trackers/feature/useFeature.tracker";

export const ShowMore = () => {
    const { sku, brand, category, reviews, totalReviews, loadMore } =
        useReviewsContext();

    const handleOnLoadMore = () => {
        UseFeatureTracker.track({
            type: "bazaarvoice",
            name: "paginate",
            page: Math.floor(reviews.length / PAGE_SIZE) + 1,
            sku: sku,
            brand: brand,
            categoryId: category
        });

        loadMore();
    };

    if (totalReviews < 2) return null;

    return (
        <Pagination
            currentNumberOfHits={reviews.length}
            totalNumberOfHits={totalReviews}
            hitsPerPage={PAGE_SIZE}
            onLoadMore={handleOnLoadMore}
        />
    );
};
